import { getCampaignStatusBadgeClass } from '../../utils/statusColors';

const STATUS_LABELS: Record<string, string> = {
  Consultation: 'Consulta',
  Confirmed: 'Confirmada',
  'In Progress': 'Em Progresso',
  Production: 'Produção',
  Billing: 'Faturação',
  Completed: 'Concluída',
};

interface CampaignStatusBadgeProps {
  status: string;
}

export function CampaignStatusBadge({ status }: CampaignStatusBadgeProps) {
  return (
    <span className={`cm-chip ${getCampaignStatusBadgeClass(status, 'soft')}`}>
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}
